import { RawShaderMaterial } from 'three';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';

/**
 * Same present dither as the login MeshGradient blobs.
 * Dithering faint smoke alpha is useless — the compositor multiplies the
 * grain away and the rings come back. Break 8-bit bands on the final
 * opaque pixels instead.
 */
const PRESENT_DITHER = {
  name: 'PresentDither',
  uniforms: {
    tDiffuse: { value: null },
  },
  vertexShader: /* glsl */ `
    precision highp float;
    uniform mat4 modelViewMatrix;
    uniform mat4 projectionMatrix;
    attribute vec3 position;
    attribute vec2 uv;
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: /* glsl */ `
    precision highp float;
    uniform sampler2D tDiffuse;
    varying vec2 vUv;

    float ign(vec2 p) {
      return fract(52.9829189 * fract(dot(p, vec2(0.06711056, 0.00583715))));
    }

    void main() {
      vec4 c = texture2D(tDiffuse, vUv);
      float n1 = ign(gl_FragCoord.xy);
      float n2 = ign(gl_FragCoord.xy + vec2(19.19, 7.77));
      float tri = n1 + n2 - 1.0;
      float luma = dot(c.rgb, vec3(0.2126, 0.7152, 0.0722));
      float strength = mix(5.2, 1.4, smoothstep(0.01, 0.18, luma)) / 255.0;
      gl_FragColor = vec4(clamp(c.rgb + tri * strength, 0.0, 1.0), 1.0);
    }
  `,
};

export function createPresentDitherPass() {
  const material = new RawShaderMaterial({
    name: PRESENT_DITHER.name,
    uniforms: {
      tDiffuse: { value: null },
    },
    vertexShader: PRESENT_DITHER.vertexShader,
    fragmentShader: PRESENT_DITHER.fragmentShader,
  });
  return new ShaderPass(material);
}
